// extracted by mini-css-extract-plugin
module.exports = {"signinsignup":"login_signinsignup__1Dd2I","signinsignupCarousel":"login_signinsignupCarousel__2C2Wm","count":"login_count__1KuHx"};